module.exports = __webpack_public_path__ + "static/media/view0.c349b24a.jpg";